var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"maincontent"},[_c('div',{staticClass:"cover",class:{'cover--show': _vm.showCover},on:{"click":_vm.hideSidebars}}),_c('router-view'),_c('PrevNextNavigation')],1)}
var staticRenderFns = []

export { render, staticRenderFns }